<template>
  <div class="media-wrapper">
    <el-button
      type="text"
      size="medium"
      @click="mediaClickHandle"
      v-show="isShowMedia">
      媒体库
    </el-button>

    <el-dialog :visible.sync="dialogVisible" :before-close="closeHandle">
      <div class="media-library">
        <div class="media-content">
          <div class="top">
            <div class="radio">
              <el-radio v-model="radio" :label="1" :disabled="isRadioDisabled(1)">图片 </el-radio>
              <el-radio v-model="radio" :label="2" :disabled="isRadioDisabled(2)">语音</el-radio>
              <el-radio v-model="radio" :label="3" :disabled="isRadioDisabled(3)">视频</el-radio>
            </div>
            <div class="btn">
              <el-button
                class="confirm"
                size="medium"
                type="primary"
                @click="confirm">
                确认
              </el-button>
              <el-button
                class="close"
                size="medium"
                type="primary"
                @click="closeHandle">
                关闭
              </el-button>
            </div>
          </div>

          <div class="center">
            <div class="img-box" v-show="radio == 1">
              <div class="img-item"
                :class="imgSelect == index ? 'active-img' : ''"
                v-for="(item, index) in imgData"
                :key="item.id"
                @click="imgSelectHandle(index, item.src)">
                <img class="img1 active" ref="imgs" :src="item.src" alt="" />
                <img class="img2" src="@/assets/imgs/media/ok.png" alt=""/>
                <div class="bg"></div>
                <div class="name">{{ item.name }}</div>
              </div>
            </div>
            <div class="music-wrapper" v-show="radio == 2">
              <div class="music-box"
                :class="musicSelect == index ? 'active-music' : ''"
                v-for="(item, index) in musicData"
                :key="item.id"
                @click="musicSelectHandle(index, item)">
                <div class="music-content">
                  <div class="music-icon" @click.stop="toggleAudioPlay(index, item)">
                    <i class="el-icon-video-pause" v-if="playingAudioIndex === index && isAudioPlaying"></i>
                    <i class="el-icon-video-play" v-else></i>
                  </div>
                  <div class="music-info">
                    <div class="music-name">{{ item.name }}</div>
                    <div class="music-progress">
                      <el-progress
                        :percentage="getAudioProgress(index)"
                        :show-text="false"
                        :stroke-width="4"
                        color="#06ca50">
                      </el-progress>
                      <span class="music-time">{{ formatTime(getAudioCurrentTime(index)) }} / {{ formatTime(getAudioDuration(index)) }}</span>
                    </div>
                  </div>
                </div>
                <img class="music-check" src="@/assets/imgs/media/ok.png" v-show="musicSelect == index"/>
                <div class="music-check-bg" v-show="musicSelect == index"></div>
              </div>
            </div>
            <div class="video-box" v-show="radio == 3">
              <div class="img-item"
                :class="videoSelect == index ? 'active-img' : ''"
                v-for="(item, index) in videoData"
                :key="item.id"
                @click="videoSelectHandle(index, item.src)">
                <template v-if="videoSelect == index">
                  <video :src="item.src" controls autoplay class="video-player" :ref="'videoPlayer_' + index"></video>
                </template>
                <template v-else>
                  <img class="img1 active" :src="item.url" alt="" />
                  <img class="video" src="@/assets/imgs/media/video.png" />
                  <div class="video-bg"></div>
                </template>
                <img class="img2" src="@/assets/imgs/media/ok.png" v-show="videoSelect == index"/>
                <div class="bg" v-show="videoSelect == index"></div>
                <div class="name">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div></div>
            <div>
              <el-pagination
                :current-page.sync="currentPage"
                :page-sizes="[8, 16, 24, 32, 48]"
                :page-size="pageNum"
                :total="pageTotal"
                layout="prev, pager, next,sizes, jumper"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isShowMedia: {
      type: Boolean,
      default: true,
    },
    filedName: String,
    mediaType: {
      type: Number,
      default: 1
    },
    show_type: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,

      // 所有媒体数据(完整数据)
      allImgData: [],
      allMusicData: [],
      allVideoData: [],

      src: '',
      imgSelect: null,
      musicSelect: null,
      videoSelect: null,

      radio: 1, // 将radio的默认值改为数�?，与FromData.vue保持一�?

      // 为每个媒体类型维护独立的分页状态
      pageStates: {
        1: { currentPage: 1, pageNum: 8 }, // 图片
        2: { currentPage: 1, pageNum: 8 }, // 语音
        3: { currentPage: 1, pageNum: 8 }  // 视频
      },

      currentAudio: null, // 用于存储当前播放的音频元�?
      playingAudioIndex: null, // 当前正在播放的音频索�?
      isAudioPlaying: false, // 音频是否正在播放
      audioProgress: {}, // 存储每个音频的播放进�?
      audioDurations: {}, // 存储每个音频的总时�?
      audioCurrentTimes: {}, // 存储每个音频的当前播放时�?
    };
  },
  computed: {
    // 当前页码
    currentPage: {
      get() {
        return this.pageStates[this.radio].currentPage;
      },
      set(val) {
        this.pageStates[this.radio].currentPage = val;
      }
    },
    // 每页数量
    pageNum: {
      get() {
        return this.pageStates[this.radio].pageNum;
      },
      set(val) {
        this.pageStates[this.radio].pageNum = val;
      }
    },
    // 当前类型的所有数据
    currentAllData() {
      if(this.radio === 1) return this.allImgData;
      if(this.radio === 2) return this.allMusicData;
      if(this.radio === 3) return this.allVideoData;
      return [];
    },
    // 当前页显示的图片数据
    imgData() {
      if(this.radio !== 1) return [];
      const start = (this.currentPage - 1) * this.pageNum;
      const end = start + this.pageNum;
      return this.allImgData.slice(start, end);
    },
    // 当前页显示的音频数据
    musicData() {
      if(this.radio !== 2) return [];
      const start = (this.currentPage - 1) * this.pageNum;
      const end = start + this.pageNum;
      return this.allMusicData.slice(start, end);
    },
    // 当前页显示的视频数据
    videoData() {
      if(this.radio !== 3) return [];
      const start = (this.currentPage - 1) * this.pageNum;
      const end = start + this.pageNum;
      return this.allVideoData.slice(start, end);
    },
    // 总数
    pageTotal() {
      return this.currentAllData.length;
    }
  },
  created() {
    this.radio = this.mediaType; // 直接使用mediaType初始化radio
  },
  methods: {
    // 停止所有媒体播�?
    stopAllMedia() {
      if (this.currentAudio) {
        this.currentAudio.pause();
        this.currentAudio = null;
        this.isAudioPlaying = false;
        this.playingAudioIndex = null;
      }
      // 暂停任何可能在模板中播放的视�?
      if (this.videoSelect !== null) {
        const videoPlayerRef = this.$refs['videoPlayer_' + this.videoSelect];
        if (videoPlayerRef && videoPlayerRef.length > 0) { // $refs in v-for returns an array
          const videoPlayer = videoPlayerRef[0];
          videoPlayer.pause();
          videoPlayer.currentTime = 0; // 重置视频到开�?
        }
      }
    },
    // 点击媒体�?
    mediaClickHandle() {
      this.dialogVisible = true;
      this.getMediaData();
      this.src = ''; // 清空src
      this.imgSelect = null; // 重置选中状�?
      this.musicSelect = null;
      this.videoSelect = null;
      this.stopAllMedia(); // 打开媒体库时停止所有播�?
    },
    // 获取媒体管理数据 - 一次性获取所有数据
    getMediaData() {
      this.$Request({
        url: this.$Api.queryDataOfResource,
        params: {
          directory_code: 'media',
          currentPage: 1,
          pageNum: 9999 // 获取所有数据
        }
      }).then(res => {
        console.log("getMediaData:>>>>>",res);
        let imgData = []
        let videoData = []
        let musicData = []
        
        res.data.forEach(item => {
          // 对名称进行URL解码
          if (item.name) {
            item.name = decodeURIComponent(item.name);
          }
          
          if(item.type === 1){
            imgData.push(item)
          }else if(item.type === 2){
            musicData.push(item) // 交换音频和视频数�?
          }else if(item.type === 3){
            videoData.push(item) // 交换音频和视频数�?
          }
        })
        
        // 保存所有数据
        this.allImgData = imgData
        this.allMusicData = musicData
        this.allVideoData = videoData
      }).catch(this.$setErrorTips);
    },

    // 关闭弹窗
    closeHandle() {
      this.dialogVisible = false;
      this.stopAllMedia(); // 关闭弹窗时停止所有播�?
    },

    // 选中图片
    imgSelectHandle(index, src) {
      this.src = src;
      this.musicSelect = null
      this.videoSelect = null
      this.imgSelect = index;
      this.stopAllMedia(); // 切换图片时停止所有播�?
    },
    musicSelectHandle(index, item) {
      this.src = item.src;
      this.imgSelect = null
      this.videoSelect = null
      this.musicSelect = index;
    },
    // 切换音频播放/暂停
    toggleAudioPlay(index, item) {
      // 如果点击的是当前正在播放的音�?
      if (this.playingAudioIndex === index && this.currentAudio) {
        if (this.isAudioPlaying) {
          this.currentAudio.pause();
          this.isAudioPlaying = false;
        } else {
          this.currentAudio.play();
          this.isAudioPlaying = true;
        }
        return;
      }
      
      // 停止之前的音�?
      this.stopAllMedia();
      
      // 播放新的音频
      if (item.src) {
        this.currentAudio = new Audio(item.src);
        this.playingAudioIndex = index;
        
        // 监听音频加载完成获取时长
        this.currentAudio.addEventListener('loadedmetadata', () => {
          this.$set(this.audioDurations, index, this.currentAudio.duration);
        });
        
        // 监听播放进度
        this.currentAudio.addEventListener('timeupdate', () => {
          if (this.currentAudio) {
            const progress = (this.currentAudio.currentTime / this.currentAudio.duration) * 100;
            this.$set(this.audioProgress, index, progress);
            this.$set(this.audioCurrentTimes, index, this.currentAudio.currentTime);
          }
        });
        
        // 监听播放结束
        this.currentAudio.addEventListener('ended', () => {
          this.isAudioPlaying = false;
          this.$set(this.audioProgress, index, 0);
          this.$set(this.audioCurrentTimes, index, 0);
        });
        
        this.currentAudio.play();
        this.isAudioPlaying = true;
      }
    },
    // 获取音频播放进度
    getAudioProgress(index) {
      return this.audioProgress[index] || 0;
    },
    // 获取音频总时�?
    getAudioDuration(index) {
      return this.audioDurations[index] || 0;
    },
    // 获取音频当前播放时间
    getAudioCurrentTime(index) {
      return this.audioCurrentTimes[index] || 0;
    },
    // 格式化时间显�?
    formatTime(seconds) {
      if (!seconds || isNaN(seconds)) return '00:00';
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    },
    videoSelectHandle(index, src) {
      console.log(`选中 style='color:red'>${index}</p>项，视频地址为${src}`);
      this.src = src;
      this.imgSelect = null
      this.musicSelect = null
      this.videoSelect = index;
      this.stopAllMedia(); // 停止其他媒体播放

      this.$nextTick(() => {
        const videoPlayerRef = this.$refs['videoPlayer_' + index];
        if (videoPlayerRef && videoPlayerRef.length > 0) { // refs in v-for return an array
          videoPlayerRef[0].play();
        }
      });
    },
    // 确认
    confirm() {
      console.log("点击确认:>>>>>>", this.filedName, this.radio);
      
      // 验证选择的媒体类型是否匹配
      if (!this.validateMediaType()) {
        return;
      }
      
      // 验证是否已选择文件
      if (!this.src) {
        this.$message({
          message: '请先选择一个文件',
          type: 'warning'
        });
        return;
      }
      
      this.$emit("imgUploaded", this.src, () => {
        this.dialogVisible = false;
        this.stopAllMedia(); // 确认后停止所有播放
      }, true); // 第三个参数标记为来自媒体库
    },
    
    // 验证媒体类型是否匹配
    validateMediaType() {
      // 检测字段名称中的关键词来确定期望的媒体类型
      const expectedType = this.detectExpectedMediaType();
      
      // 如果无法检测到期望类型，允许选择任何类型
      if (expectedType === null) {
        return true;
      }
      
      // 验证当前选择的类型是否匹配期望类型
      if (this.radio !== expectedType) {
        const typeNames = {
          1: '图片',
          2: '语音',
          3: '视频'
        };
        const expectedName = typeNames[expectedType] || '文件';
        const currentName = typeNames[this.radio] || '文件';
        
        this.$message({
          message: `当前字段仅支持上传${expectedName}文件，但您选择了${currentName}文件，请重新选择`,
          type: 'error'
        });
        return false;
      }
      
      return true;
    },
    
    // 根据字段名称检测期望的媒体类型
    detectExpectedMediaType() {
      // 优先使用传入的 show_type
      if (this.show_type === 6) return 1; // 图片
      if (this.show_type === 8) return 2; // 语音
      if (this.show_type === 9) return 3; // 视频
      
      // 如果没有 show_type，使用 mediaType
      if (this.mediaType !== null && this.mediaType !== undefined) {
        return this.mediaType;
      }
      
      // 如果都没有，根据字段名称关键词判断
      if (!this.filedName) {
        return null;
      }
      
      const fieldNameLower = this.filedName.toLowerCase();
      
      // 图片关键词
      const imageKeywords = ['图片', '图像', '照片', 'image', 'img', 'photo', 'picture', 'pic',
                             '地图', 'map', '封面', 'cover', '头像', 'avatar', '缩略图',
                             'thumbnail', 'thumb', 'logo', 'icon', '图标', '背景', 'background', 'bg', 'banner'];
      
      // 音频关键词
      const audioKeywords = ['语音', '音频', '音乐', '录音', 'audio', 'voice', 'sound',
                             'music', 'mp3', '播报', '朗读', '讲解'];
      
      // 视频关键词
      const videoKeywords = ['视频', '影片', '录像', 'video', 'movie', 'film', 'mp4',
                             '短片', '宣传片'];
      
      // 检查图片关键词
      if (imageKeywords.some(keyword => fieldNameLower.includes(keyword.toLowerCase()))) {
        return 1;
      }
      
      // 检查音频关键词
      if (audioKeywords.some(keyword => fieldNameLower.includes(keyword.toLowerCase()))) {
        return 2;
      }
      
      // 检查视频关键词
      if (videoKeywords.some(keyword => fieldNameLower.includes(keyword.toLowerCase()))) {
        return 3;
      }
      
      // 没有匹配到任何关键词，返回 null（不限制类型）
      return null;
    },
    
    // 判断某个radio选项是否应该被禁用
    isRadioDisabled(radioValue) {
      const expectedType = this.detectExpectedMediaType();
      
      // 如果没有检测到期望类型，所有选项都可用
      if (expectedType === null) {
        return false;
      }
      
      // 只有期望类型的选项可用，其他都禁用
      return radioValue !== expectedType;
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageNum = val;
      // 重置到第一页
      this.currentPage = 1;
      this.stopAllMedia(); // 分页时停止所有播放
    },
    handleCurrentChange(val) {
      console.log(`当前页 ${val}`);
      this.currentPage = val;
      this.stopAllMedia(); // 分页时停止所有播放
    },
  },
  watch: {
    radio(newVal) {
      this.stopAllMedia(); // 切换媒体类型时停止所有播放
      // 重置选中状态
      this.imgSelect = null;
      this.musicSelect = null;
      this.videoSelect = null;
    }
  },
  beforeDestroy() {
    this.stopAllMedia(); // 组件销毁前停止所有播放
  }
};
</script>
<style lang="scss" scoped>
.media-wrapper {
  :deep(.el-button--text) {
    color: #fff !important;
  }
  :deep(.el-dialog) {
    width: 760px;
  }
  :deep(.el-dialog__header){
    display: none !important;
  }
  :deep(.el-dialog__body) {
    padding: 0;
  }
}

.media-library {
  height: 475px;
  :deep(.el-input__inner) {
    margin: 0;
  }

  .media-content {
    position: relative;
    // padding: 42px 45px 28px 40px;
    padding: 10px;
    // width: 760px;
    width: 100%;
    height: 100%;
    margin-top: 3px;

    .top {
      display: flex;
      justify-content: space-between;
      .btn {
        margin-bottom: 20px;
        .confirm {
          background: #39da86;
          border-color: #39da86;
        }
        .close {
          background: #433cf0;
          border-color: #433cf0;
        }
      }
    }
    .center {
      .img-box,
      .video-box {
        // width: 675px;
        width: 100%;
        // height: 306px;
        height: 346px;
        overflow-y: auto;
        overflow-x: hidden;

        /* display: flex;
        justify-content: space-between;
        flex-wrap: wrap; */

        .active-img {
          .img2 {
            position: absolute;
            top: 3px;
            right: 1px;
            z-index: 113;
            transform: scale(0.8);
          }
          .bg {
            width: 35px;
            height: 35px;
            background: #06ca50;

            position: absolute;
            right: -17px;
            top: -17px;
            z-index: 112;
            transform: rotate(45deg);
          }
          .active {
            border: 2px solid #06ca50;
            border-radius: 4px;
          }
        }
        .img-item {
          position: relative;
          // width: 158px;
          display: inline-block;
          width: calc((100% - 30px) / 4);
          margin-right: 10px;
          height: 158px;
          overflow: hidden;
          // margin: 0 5px;
          // margin-bottom: 15px;
          &:nth-child(4n){
            margin-right: 0;
          }

          .img1 {
            // width: 158px;
            width: 100%;
            // height: 138px;
            height: 158px;
            border-radius: 4px;
            z-index: 110;
            position: relative;
          }
          .name {
            // width: 154px;
            width: 100%;
            height: 25px;
            line-height: 25px;
            font-size: 12px;
            padding-left: 7px;
            box-sizing: border-box;
            // margin-left: 2px;
            background: #181b1e;
            opacity: 0.9;
            position: absolute;
            z-index: 110;
            bottom: 0;
            color: #fff;
          }
          .video {
            width: 34px;
            height: 40px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -17px;
            margin-left: -20px;
            z-index: 115;
          }
          .video-bg {
            // width: 158px;
            width: 100%;
            height: 100%;
            // height: 113px;
            position: absolute;
            opacity: 0.6;
            background: #666666;
            top: 0;
            left: 0;
            z-index: 111;
          }
          .video-player {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }
        }
      }
      .music-wrapper {
        display: flex;
        flex-wrap: wrap;
        height: 346px;
        overflow-y: auto;
        align-content: flex-start;
        
        .music-box {
          position: relative;
          width: calc(50% - 10px);
          height: 70px;
          margin-right: 20px;
          margin-bottom: 15px;
          background: #fff;
          border-radius: 8px;
          cursor: pointer;
          overflow: hidden;
          border: 1px solid #e0e0e0;
          
          &:nth-child(2n) {
            margin-right: 0;
          }
          
          &.active-music {
            border: 2px solid #06ca50;
          }
          
          .music-content {
            display: flex;
            align-items: center;
            height: 100%;
            padding: 0 15px;
            
            .music-icon {
              width: 44px;
              height: 44px;
              background: #06ca50;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 12px;
              flex-shrink: 0;
              
              i {
                font-size: 32px;
                color: #fff;
              }
            }
            
            .music-info {
              flex: 1;
              overflow: hidden;
              
              .music-name {
                font-size: 14px;
                color: #333;
                margin-bottom: 8px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              
              .music-progress {
                display: flex;
                align-items: center;
                
                :deep(.el-progress) {
                  flex: 1;
                  margin-right: 10px;
                  
                  .el-progress-bar__outer {
                    background-color: #e0e0e0;
                  }
                }
                
                .music-time {
                  font-size: 12px;
                  color: #666;
                  white-space: nowrap;
                }
              }
            }
          }
          
          .music-check {
            position: absolute;
            top: 3px;
            right: 1px;
            z-index: 113;
            transform: scale(0.8);
          }
          
          .music-check-bg {
            width: 35px;
            height: 35px;
            background: #06ca50;
            position: absolute;
            right: -17px;
            top: -17px;
            z-index: 112;
            transform: rotate(45deg);
          }
        }
      }
    }
    .bottom {
      position: absolute;
      bottom: 10px;
      right: 10px;
      // margin-top: 20px;
      // margin-top: 65px;
      display: flex;
      justify-content: space-between;

      /* 分页 */

      :deep(.el-pagination__jump) {
        margin: 0;
      }
      :deep(.el-pager) li.active {
        color: #fff;
        background-color: #433cf0;
        border-radius: 4px;
        margin: 0 6px;
      }
      :deep(.el-pagination) .btn-prev,
      :deep(.el-pagination) .btn-next {
        padding: 0;
        border-radius: 4px;
        border: 1px solid #433cf0;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.media-wrapper {
  :deep(.el-button--text) {
    color: #fff !important;
  }
  :deep(.el-dialog) {
    width: 760px;
  }
  :deep(.el-dialog__header){
    display: none !important;
  }
  :deep(.el-dialog__body) {
    padding: 0;
  }
}

.media-library {
  height: 475px;
  :deep(.el-input__inner) {
    margin: 0;
  }

  .media-content {
    position: relative;
    // padding: 42px 45px 28px 40px;
    padding: 10px;
    // width: 760px;
    width: 100%;
    height: 100%;
    margin-top: 3px;

    .top {
      display: flex;
      justify-content: space-between;
      .btn {
        margin-bottom: 20px;
        .confirm {
          background: #39da86;
          border-color: #39da86;
        }
        .close {
          background: #433cf0;
          border-color: #433cf0;
        }
      }
    }
    .center {
      .img-box,
      .video-box {
        // width: 675px;
        width: 100%;
        // height: 306px;
        height: 346px;
        overflow-y: auto;
        overflow-x: hidden;

        /* display: flex;
        justify-content: space-between;
        flex-wrap: wrap; */

        .active-img {
          .img2 {
            position: absolute;
            top: 3px;
            right: 1px;
            z-index: 113;
            transform: scale(0.8);
          }
          .bg {
            width: 35px;
            height: 35px;
            background: #06ca50;

            position: absolute;
            right: -17px;
            top: -17px;
            z-index: 112;
            transform: rotate(45deg);
          }
          .active {
            border: 2px solid #06ca50;
            border-radius: 4px;
          }
        }
        .img-item {
          position: relative;
          // width: 158px;
          display: inline-block;
          width: calc((100% - 30px) / 4);
          margin-right: 10px;
          height: 158px;
          overflow: hidden;
          // margin: 0 5px;
          // margin-bottom: 15px;
          &:nth-child(4n){
            margin-right: 0;
          }

          .img1 {
            // width: 158px;
            width: 100%;
            // height: 138px;
            height: 158px;
            border-radius: 4px;
            z-index: 110;
            position: relative;
          }
          .name {
            // width: 154px;
            width: 100%;
            height: 25px;
            line-height: 25px;
            font-size: 12px;
            padding-left: 7px;
            box-sizing: border-box;
            // margin-left: 2px;
            background: #181b1e;
            opacity: 0.9;
            position: absolute;
            z-index: 110;
            bottom: 0;
            color: #fff;
          }
          .video {
            width: 34px;
            height: 40px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -17px;
            margin-left: -20px;
            z-index: 115;
          }
          .video-bg {
            // width: 158px;
            width: 100%;
            height: 100%;
            // height: 113px;
            position: absolute;
            opacity: 0.6;
            background: #666666;
            top: 0;
            left: 0;
            z-index: 111;
          }
        }
      }
      .music-wrapper {
        display: flex;
        flex-wrap: wrap;
        height: 346px;
        overflow-y: auto;
        align-content: flex-start;
        
        .music-box {
          position: relative;
          width: calc(50% - 10px);
          height: 70px;
          margin-right: 20px;
          margin-bottom: 15px;
          background: #fff;
          border-radius: 8px;
          cursor: pointer;
          overflow: hidden;
          border: 1px solid #e0e0e0;
          
          &:nth-child(2n) {
            margin-right: 0;
          }
          
          &.active-music {
            border: 2px solid #06ca50;
          }
          
          .music-content {
            display: flex;
            align-items: center;
            height: 100%;
            padding: 0 15px;
            
            .music-icon {
              width: 44px;
              height: 44px;
              background: #06ca50;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 12px;
              flex-shrink: 0;
              
              i {
                font-size: 32px;
                color: #fff;
              }
            }
            
            .music-info {
              flex: 1;
              overflow: hidden;
              
              .music-name {
                font-size: 14px;
                color: #333;
                margin-bottom: 8px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              
              .music-progress {
                display: flex;
                align-items: center;
                
                :deep(.el-progress) {
                  flex: 1;
                  margin-right: 10px;
                  
                  .el-progress-bar__outer {
                    background-color: #e0e0e0;
                  }
                }
                
                .music-time {
                  font-size: 12px;
                  color: #666;
                  white-space: nowrap;
                }
              }
            }
          }
          
          .music-check {
            position: absolute;
            top: 3px;
            right: 1px;
            z-index: 113;
            transform: scale(0.8);
          }
          
          .music-check-bg {
            width: 35px;
            height: 35px;
            background: #06ca50;
            position: absolute;
            right: -17px;
            top: -17px;
            z-index: 112;
            transform: rotate(45deg);
          }
        }
      }
    }
    .bottom {
      position: absolute;
      bottom: 10px;
      right: 10px;
      // margin-top: 20px;
      // margin-top: 65px;
      display: flex;
      justify-content: space-between;

      /* 分页 */

      :deep(.el-pagination__jump) {
        margin: 0;
      }
      :deep(.el-pager) li.active {
        color: #fff;
        background-color: #433cf0;
        border-radius: 4px;
        margin: 0 6px;
      }
      :deep(.el-pagination) .btn-prev,
      :deep(.el-pagination) .btn-next {
        padding: 0;
        border-radius: 4px;
        border: 1px solid #433cf0;
      }
    }
  }
}
</style>

